import { BenefitLayout } from "providers/benefit-layout";
import React, { Dispatch, FC, SetStateAction } from "react";
import { Link } from "react-router-dom";
import { CheckboxCard } from "shared/components/forms/CheckboxCard";
import { Radio } from "shared/components/forms/Radio";
import { Button, ButtonVariant } from "shared/components/Button";
import { SelectOption } from "../types";

type Props = {
  handleContinue: () => void;
  options: {
    id: string;
    title: string;
  }[];
  selectedOption: SelectOption;
  setSelectedOption: Dispatch<SetStateAction<SelectOption>>;
  title: string;
  subtitle: string;
};

export const SelectScreenView: FC<Props> = ({
  handleContinue,
  options,
  selectedOption,
  setSelectedOption,
  title,
  subtitle
}) => {
  return (
    <BenefitLayout
      hasBack={true}
      title={title}
      mainClassName="max-w-[440px] w-full mx-auto md:mt-4"
      footer={
        <div className="max-w-[440px] mx-auto w-full">
          <Button
            variant={ButtonVariant.PRIMARY}
            className="w-full"
            onClick={handleContinue}
          >
            Continue
          </Button>
          <Link to={"/hub"} className="w-full md:block hidden mt-2">
            <Button className="w-full">Back</Button>
          </Link>
        </div>
      }
    >
      <div>
        <p className="text-sm text-content-600 mb-6">{subtitle}</p>
        {options.map((option) => {
          return (
            <CheckboxCard
              key={option.id}
              id={option.id}
              name={option.id}
              label={
                <div className="flex h-full w-full items-center gap-4">
                  <Radio
                    id={option.id}
                    name={option.id}
                    checked={selectedOption === option.id}
                    onChange={() =>
                      setSelectedOption(option.id as SelectOption)
                    }
                  />
                  <p className="font-bold text-content-1000 text-sm ">
                    {option.title}
                  </p>
                </div>
              }
              checked={selectedOption === option.id}
              onChange={() => setSelectedOption(option.id as SelectOption)}
              className="mb-2"
            />
          );
        })}
      </div>
    </BenefitLayout>
  );
};
